export const ContactTableHeaders = ["email", "phone-number", "modify"];
